import { Fragment } from "react";
import "../App.css"


const Contact = () => {
  return (
    <Fragment>
        <div class="container">
    <div class="content">
      <div class="left-side">
        <div class="address details">
          <i class="fas fa-map-marker-alt"></i>
          <div class="topic">Address</div>
          <div class="text-one">Tokha, Ward-2</div>
          <div class="text-two">Province-Bagmati,Kathmandu</div>
        </div>
        <div class="phone details">
          <i class="fas fa-phone-alt"></i>
          <div class="topic">Phone</div>
          <div class="text-one">+977 9860123694</div>
          <div class="text-two">+977 9860123694</div>
        </div>
        <div class="email details">
          <i class="fas fa-envelope"></i>
          <div class="topic">Email</div>
          <div class="text-one">nepayouthclub@gmail.com</div>
          <div class="text-two">info.nepayouthclub@gmail.com</div>
        </div>
      </div>
      <div class="right-side">
        <div class="topic-text">Send us a message</div>
        <p>If you have any work or messege to our club you can find us from here. It's my pleasure to help you.</p>
      <form action="#">
        <div class="input-box">
          <input type="text" placeholder="Enter your name"/>
        </div>
        <div class="input-box">
          <input type="text" placeholder="Enter your email"/>
        </div>
        <div class="input-box message-box">
          <input type="text" placeholder="Enter your Message"/>
        </div>
        <div class="button">
          <input type="button" value="Send Now" />
        </div>
      </form>
      <hr/>
    </div>
    </div>
  </div>
  <br/>
    </Fragment>
  );
};

export default Contact;

